export class SearchResources200Response {
    'tables';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tables",
            "baseName": "tables",
            "type": "Array<SearchResources200ResponseTablesInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchResources200Response.attributeTypeMap;
    }
    constructor() {
    }
}
